import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

interface ChartPortalProps {
  children: React.ReactNode;
  portalId?: string;
}

// Prevents modal from unmounting when parent components re-render
const ChartPortal: React.FC<ChartPortalProps> = ({
  children,
  portalId = 'chart-portal-root',
}) => {
  const [mounted, setMounted] = useState(false);
  const [portalElement, setPortalElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    let element = document.getElementById(portalId);

    if (!element) {
      element = document.createElement('div');
      element.id = portalId;
      element.style.position = 'relative';
      element.style.zIndex = '9999'; // Ensure modal appears above other content
      document.body.appendChild(element);
    }

    setPortalElement(element);
    setMounted(true);

    return () => {
      setMounted(false);
    };
  }, [portalId]);

  if (!mounted || !portalElement) {
    return null;
  }

  return ReactDOM.createPortal(children, portalElement);
};

ChartPortal.displayName = 'ChartPortal';

export default ChartPortal;
